import React, { useEffect, useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
const WHATSAPP_URL = 'https://wa.me/447311754270?text=WEBSITE';
export function FloatingWhatsApp() {
  const {
    t
  } = useLang();
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [dismissedTooltip, setDismissedTooltip] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Auto-reveal the tooltip shortly after the button appears
  useEffect(() => {
    if (visible && !dismissedTooltip) {
      const timer = setTimeout(() => setShowTooltip(true), 1200);
      return () => clearTimeout(timer);
    }
  }, [visible, dismissedTooltip]);
  return <AnimatePresence data-id="element-44" data-mp="3oeutymasdabe">
      {visible && <motion.div initial={{
      opacity: 0,
      scale: 0.5,
      y: 30
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.5,
      y: 30
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 flex items-center gap-3" data-id="element-45" data-mp="3odt6ficl2vcs">
          {/* Premium tooltip / mini card */}
          <AnimatePresence data-id="element-46" data-mp="aywxqjndf856">
            {showTooltip && <motion.div initial={{
          opacity: 0,
          x: 20,
          scale: 0.9
        }} animate={{
          opacity: 1,
          x: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          x: 20,
          scale: 0.9
        }} transition={{
          duration: 0.25
        }} className="relative hidden sm:block bg-dark-100 border border-[#25D366]/30 rounded-2xl pl-4 pr-9 py-3 shadow-[0_8px_30px_rgba(0,0,0,0.5)] max-w-[230px]" data-id="element-47" data-mp="fyszec8linhk">
                <button onClick={() => {
            setShowTooltip(false);
            setDismissedTooltip(true);
          }} aria-label={t.floating.closeLabel} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" data-id="element-48" data-mp="2rnk7w0be1poi">
                  <X className="w-3.5 h-3.5" data-id="element-49" data-mp="jijlj31t5z0m" />
                </button>
                <p className="text-white text-sm font-bold leading-tight" data-id="element-50" data-mp="eixbf2ha0yw1">
                  {t.floating.title}
                </p>
                <p className="text-gray-400 text-xs mt-0.5 leading-snug" data-id="element-51" data-mp="9jkokhqenrtg">
                  {t.floating.text}
                </p>
                {/* arrow */}
                <div className="absolute top-1/2 -right-1.5 -translate-y-1/2 w-3 h-3 rotate-45 bg-dark-100 border-r border-b border-[#25D366]/30" data-id="element-52" data-mp="4mkhq4lqel1a" />
              </motion.div>}
          </AnimatePresence>

          {/* Button with pulse rings */}
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label={t.floating.aria} onMouseEnter={() => setShowTooltip(true)} className="relative inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] text-white shadow-[0_0_25px_rgba(37,211,102,0.5)] transition-transform hover:scale-110" data-id="element-53" data-mp="1uyi4bymsfzf1">
            {/* animated pulse rings */}
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" data-id="element-54" data-mp="2twh8rkjlehbd" />
            <span className="absolute inset-0 rounded-full ring-2 ring-[#25D366]/40" data-id="element-55" data-mp="2yuite9wo2ooy" />
            <MessageCircle className="relative w-7 h-7 sm:w-8 sm:h-8" data-id="element-56" data-mp="32wvxktvrmejm" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}